import { H4, P, SmallText } from '@/components/common/Typo'
import {
  ChevronDownIcon,
  ChevronUpIcon,
  cn,
  Collapsible,
  CollapsibleContent,
} from 'oddle-shop-monorepo.design-system'
import { ReactNode } from 'react'

export const Header = ({
  error,
  show,
  title,
  subtitle,
  body,
  bodySubText,
  hideArrow,
  className,
}: {
  error?: boolean
  show?: boolean
  title: ReactNode
  subtitle: ReactNode
  body: ReactNode
  bodySubText?: ReactNode
  hideArrow?: boolean
  className?: string
}) => (
  <div
    className={cn(
      'flex w-full cursor-pointer justify-between rounded-lg p-2.5 lg:p-5 lg:py-2.5',
      error ? 'bg-[#FFEEEB]' : 'bg-[#F6F6F6]',
      className
    )}
  >
    <div className="flex w-3/5 flex-col">
      <H4 className={cn('m-0', error ? 'text-red-500' : 'text-[#393939]')} bold>
        {title}
      </H4>
      <SmallText
        className={cn('m-0', error ? 'text-red-500' : 'text-[#393939]')}
      >
        {subtitle}
      </SmallText>
    </div>
    <div className="flex w-2/5 items-center justify-end">
      <div className="flex flex-col items-end">
        <P
          className={cn('m-0', error ? 'text-red-500' : 'text-[#393939]')}
          textAlign="right"
        >
          {body}
        </P>
        <P
          className={cn('m-0', error ? 'text-red-500' : 'text-[#393939]')}
          data-testid="text.bodySubText"
        >
          {bodySubText}
        </P>
      </div>
      {!hideArrow && (
        <div className="flex">
          {show ? (
            <ChevronUpIcon className="text-3xl text-[#393939]" />
          ) : (
            <ChevronDownIcon className="text-3xl text-[#393939]" />
          )}
        </div>
      )}
    </div>
  </div>
)

export const ContentContainer = ({
  children,
  show,
}: {
  children: ReactNode
  show: boolean
}) => (
  <Collapsible open={show}>
    <CollapsibleContent>
      <div className="flex flex-col">{children}</div>
    </CollapsibleContent>
  </Collapsible>
)

export const ItemContainer = ({
  children,
  disabled,
  last,
  className,
}: {
  children: ReactNode
  disabled?: boolean
  last?: boolean
  className?: string
}) => {
  return (
    <div
      className={cn(
        'flex min-h-16 items-center justify-between p-2.5 lg:p-5 lg:py-2.5',
        disabled ? 'opacity-50' : '',
        last ? '' : 'border-b-lines-and-borders border-b border-solid',
        className
      )}
    >
      {children}
    </div>
  )
}
